import queryString from 'query-string';

export function keyExistsInQueryString(
  key: string,
  qs = window.location.search
): boolean {
  return key in queryString.parse(qs);
}

export function getValueFromQueryString(
  key: string,
  qs = window.location.search
): string | string[] | null | undefined {
  return queryString.parse(qs)[key];
}

export function getStringValueFromQueryString(
  key: string,
  qs = window.location.search
): string | null {
  const val = getValueFromQueryString(key, qs);
  if (Array.isArray(val)) {
    return val[0];
  }
  return val ?? null;
}
